import React, { Fragment } from "react";
import { connect } from "react-redux";
import { ApplicationState, ConnectedReduxProps } from "@reducers/index";
import { Supplier } from "@models/supplier";
import {
  deleteRequest,
  fetchRequest,
  createRequest,
  updateRequest
} from "@actions/supplier";
import SupplierForm from "@components/supplier/Form";
import supplierApi from "@api/supplier";
import { injectIntl } from "react-intl";

interface PropsFromState {
  loading: boolean;
  data: Supplier[];
  errors?: string;
  count: number;
}

interface PropsFromDispatch {
  fetchRequest: typeof fetchRequest;
  deleteRequest: typeof deleteRequest;
}

// Combine both state + dispatch props - as well as any props we want to pass - in a union type.
type AllProps = PropsFromState & PropsFromDispatch & ConnectedReduxProps;

class SupplierFormPage extends React.Component<AllProps> {
  state = {
    supplier: null,
    supplier_id: this.props.match.params.id,
    is_fetched: false
  };

  componentDidMount() {
    if (this.state.supplier_id) {
      this.fetchItem();
    }
  }

  fetchItem = () => {
    supplierApi
      .getItem({
        params: {
          id: this.state.supplier_id
        }
      })
      .then(({ data }) => {
        this.setState({
          supplier: data
        });
      })
      .catch(error => console.log(error));
  };

  getContent = () => {
    if (this.state.supplier_id && !this.state.supplier) {
      return null;
    }

    return (
      <SupplierForm
        supplier={this.state.supplier}
        intl={this.props.intl}
        listUrl={"/suppliers"}
        history={this.props.history}
        updateRequest={this.props.updateRequest}
        createRequest={this.props.createRequest}
      />
    );
  };

  render() {
    return <Fragment>{this.getContent()}</Fragment>;
  }
}

const mapStateToProps = ({ supplier }: ApplicationState) => ({
  loading: supplier.loading,
  errors: supplier.errors
});

const mapDispatchToProps = {
  createRequest,
  updateRequest
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(injectIntl(SupplierFormPage));
